<template>
  <div>
    <div
      v-if="!dataLoaded"
      class="text-center"
    >
      <v-progress-circular
        class="mt-6"
        :size="50"
        color="primary"
        indeterminate
      />
    </div>

    <div
      v-show="dataLoaded"
      class="mt-4"
    >
      <v-row class="my-0">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card pb-4 px-4"
          >
            <v-card-title class="mb-0 pb-0 d-flex flex-nowrap justify-space-between">
              <h4
                style="text-overflow: ellipsis"
                class="overflow-hidden text-no-wrap"
              >{{ title }}</h4>

              <div class="d-inline-flex">
                <SearchElement
                  v-if="!isXs"
                  :search-props.sync="search"
                  class="mr-3"
                />

                <v-btn
                  outlined
                  small
                  color="primary"
                  class="action-btn elevation-0 rounded-lg"
                  height="32"
                  @click="addBtnClick"
                >
                  <v-icon
                    v-if="!isXs"
                    class="uikit-icon plus primary size-20"
                  />
                  <span class="btn-text">Добавить</span>
                </v-btn>
              </div>
            </v-card-title>

            <SearchElement
              v-if="isXs"
              :search-props.sync="search"
              class="mt-4 px-4"
            />

            <v-card-text class="my-0 py-0">
              <v-data-table
                v-if="!isXs"
                ref="table"
                hide-default-footer
                fixed-header
                class="base-table elevation-0 mt-2"
                loading-text="Загрузка"
                :search="search"
                :loading="tableLoading"
                :headers="tableHeaders"
                :items="data"
                :items-per-page="-1"
              >

                <template #item="{ item }">
                  <tr>
                    <td
                      v-for="header of tableHeaders"
                      :key="header.value"
                      :class="`text-${header.align}`"
                    >
                      <span> {{ getNormalizeTableFieldValue(item[header.value]) }}</span>

                      <div
                        v-if="header.value === 'actions'"
                        class="d-flex justify-center align-center"
                        style="gap: 16px"
                      >
                        <v-icon
                          class="uikit-icon edit-icon edit-btn"
                          title="Редактировать"
                          @click="edit(item)"
                        />
                        <v-icon
                          class="uikit-icon trash remove-btn"
                          title="Удалить"
                          @click="remove(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>

                <template slot="no-data">
                  <div>Таблица пуста</div>
                </template>

                <template slot="no-results">
                  <div>Результаты не найдены</div>
                </template>
              </v-data-table>

              <v-list
                v-if="isXs"
                ref="list"
                class="px-4 pt-0 transparent overflow-auto"
              >
                <v-row class="my-0 mt-4">
                  <v-col
                    v-for="(item) of searchedData"
                    :key="item.id"
                    cols="12"
                    sm="6"
                    lg="4"
                    xl="3"
                    class="pt-0 d-flex"
                    :class="$vuetify.breakpoint.xs ? 'px-0' : ''"
                  >
                    <v-card
                      class="base-card hover-card cursor-pointer pb-2 px-1 w-full d-flex flex-column justify-space-between"
                      :ripple="false"
                    >
                      <div>
                        <v-card-title class="d-flex justify-space-between card-title-link-text">
                          <span>{{ item[titleFieldName] }}</span>
                        </v-card-title>

                        <v-card-text>
                          <div
                            v-for="(header, i) of tableHeaders.filter(el => ![titleFieldName, 'actions'].includes(el.value))"
                            :key="i"
                          >
                            <strong>{{ header.text }}:</strong> {{ getNormalizeTableFieldValue(item[header.value]) }}
                          </div>
                        </v-card-text>
                      </div>

                      <v-card-actions class="d-flex justify-end">
                        <v-icon
                          class="mr-2 uikit-icon edit-icon edit-btn"
                          title="Редактировать"
                          @click="edit(item)"
                        />
                        <v-icon
                          class="uikit-icon trash remove-btn"
                          title="Удалить"
                          @click="remove(item)"
                        />
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SearchElement from '@/ui/SearchElement'
import _ from 'lodash'
import MenuButton from '@/components/Spm/Events/FilledFormValuePage/elements/MenuButton.vue'
import { getNormalizeTableFieldValue } from '@/scripts/utils'

export default {
  name: 'DirectoryTable',
  components: { MenuButton, SearchElement },
  props: {
    title: {
      type: String,
      default: null,
    },
    tableHeaders: {
      type: Array,
      default: null,
    },
    tableLoading: {
      type: Boolean,
      default: null,
    },
    dataLoaded: {
      type: Boolean,
      default: null,
    },
    data: {
      type: Array,
      default: null,
    },
    searchFieldName: {
      type: String,
      default: 'name'
    },
    titleFieldName: {
      type: String,
      default: 'name'
    }
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  data: () => ({
    search: '',
  }),

  computed: {
    ...mapState('directoryPage', ['isShowTabs']),
    ...mapGetters('breakpoint', ['isXs']),

    searchedData() {
      return this.search ?
        this.data.filter((i) => i[this.searchFieldName].toLowerCase().includes(this.search.toLowerCase())) : this.data
    },
  },

  methods: {
    getNormalizeTableFieldValue,
    edit(item) {
      this.$emit('edit', item)
    },

    remove(item) {
      this.$emit('remove', item)
    },

    addBtnClick() {
      this.$emit('addBtnClick')
    },

    setTableHeight() {
      this.$nextTick(() => {
        const footerHeight = 67
        if (this.$refs?.table) {
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top

          this.$refs.table.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
        if (this.$refs?.list) {
          const topHeight = this.$refs.list.$el.getBoundingClientRect().top

          this.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },


    isShowTabs() {
      this.setTableHeight()
    },

    isXs() {
      this.isXs && this.setTableHeight()
    },
  },
}
</script>
